
import React, { useState, useEffect } from 'react';
import styles from '../../../src/assets/scss/CreateOrders.module.scss';
import Select from 'react-select';
import { useLazyGetBillingItemsQuery } from '../../slices/admin/admin';
import { toast } from 'react-toastify';

const ApprovePopup = ({ closePopup, itemData = null, editIndex = undefined, orderId }) => {

    //console.log('ApprovePopup itemData:', itemData);


    const [selectedItem, setSelectedItem] = useState('');
    const [quantity, setQuantity] = useState('');
    const [bagType, setBagType] = useState('');
    const [addedBillingItems, setAddedBillingItems] = useState([{ billingItemId: '', billingItemQuantity: '' }]);
    //const [itemIds, setItemIds] = useState(itemData?._id || '');

    const [triggerBillingItems, { data: billingItemsData = [], isLoading, isError }] = useLazyGetBillingItemsQuery();

    // useEffect(() => {
    //     if (itemData) {
    //         setSelectedItem(itemData.itemId || '');
    //         setQuantity(itemData.overallQuantity || '');
    //         setBagType(itemData.productBag || '');
    //         setAddedBillingItems(itemData.addedBillingItems || [{ billingItemId: '', billingItemQuantity: '' }]);
    //     }
    // }, [itemData.orderId]);

    useEffect(() => {
        if (itemData) {
            setSelectedItem(itemData.itemId || '');
            
            let calculatedQty = itemData.overallQuantity || '';

            // If overallQuantity is missing, calculate it from Count * Scale weight
            if (!calculatedQty || calculatedQty === 0) {
                const bag = itemData.bagType || itemData.productBag || '';
                const weightMatch = bag.match(/\d+/);
                const weight = weightMatch ? Number(weightMatch[0]) : 0;
                const count = Number(itemData.productCount || 0);

                if (weight > 0 && count > 0) {
                    calculatedQty = weight * count;
                } else if (itemData.productQuantity && Number(itemData.productQuantity) > 0) {
                    // Fallback to productQuantity if it's a "kilogram" bag or direct kg input
                    calculatedQty = itemData.productQuantity;
                }
            }

            setQuantity(calculatedQty);
            setBagType(itemData.bagType || itemData.productBag || '');

            const formatted = Array.isArray(itemData.addedBillingItems)
                ? itemData.addedBillingItems
                : [{
                    billingItemId: itemData.billingItemId || '',
                    billingItemQuantity: itemData.qty || '',
                }];

            setAddedBillingItems(formatted);
        }
    }, [itemData]);



    // useEffect(() => {
    //     if (itemData?.itemName) {
    //         triggerBillingItems({ productName: itemData.itemName });
    //     }
    // }, [itemData?.itemName]);

    useEffect(() => {
        if (itemData?.itemName) {
            triggerBillingItems({ productName: itemData.itemName });
        }
    }, [itemData?.itemName]);



    // const billingItemOptions = (billingItemsData?.result || []).map((item) => ({
    //     value: item._id,
    //     label: `Item ID ${item.itemId} - ${item.productName} - ${item.overallQuantity} kg`,
    // }));


    // const billingItemOptions = (billingItemsData?.result || []).map((item) => ({
    //     value: item._id,
    //     label: `Item ID ${item.itemId} - ${item.productName} - ${item.overallQuantity} kg`,
    //     overallQuantity: item.overallQuantity,
    // }));

    const billingItemOptions = (billingItemsData?.result || []).map((item) => ({
        value: item._id,
        label: `${item.inventoryId?.farmerId?.firstName || "Unknown"} - ID ${item.itemId} - ${item.productName} - ${item.overallQuantity}kg`,
        overallQuantity: item.overallQuantity,
        farmerName: item.inventoryId?.farmerId?.firstName || "Unknown",
        itemId: item.itemId,
        productName: item.productName,
        productBag: item.productBag || "",
    }));


    // const handleBillingItemChange = (index, field, value) => {
    //     if (field === "billingItemQuantity") {
    //         const totalEntered = addedBillingItems.reduce((sum, item, i) => {
    //             if (i !== index) {
    //                 return sum + Number(item.billingItemQuantity || 0);
    //             }
    //             return sum;
    //         }, 0);

    //         const newTotal = totalEntered + Number(value || 0);

    //         if (newTotal > Number(quantity)) {
    //             toast.error("You cannot enter more than the Over All Quantity");
    //             return;
    //         }

    //         const selectedItem = addedBillingItems[index];
    //         if (selectedItem?.billingItemId) {
    //             const itemData = billingItemOptions.find(
    //                 (opt) => opt.value === selectedItem.billingItemId
    //             );

    //             if (
    //                 itemData?.overallQuantity &&
    //                 Number(value) > Number(itemData.overallQuantity)
    //             ) {
    //                 toast.error(
    //                     `Quantity cannot exceed ${itemData.overallQuantity} for this item`
    //                 );
    //                 return;
    //             }
    //         }
    //     }

    //     const updated = [...addedBillingItems];
    //     updated[index][field] = value;
    //     setAddedBillingItems(updated);
    // };





    // const handleBillingItemChange = (index, field, value) => {
    //     if (field === 'billingItemQuantity') {
    //         const totalEntered = addedBillingItems.reduce((sum, item, i) => {
    //             if (i !== index) {
    //                 return sum + Number(item.billingItemQuantity || 0);
    //             }
    //             return sum;
    //         }, 0);

    //         const newTotal = totalEntered + Number(value || 0);
    //         if (newTotal > Number(quantity)) {
    //             toast.error('You cannot enter more than the Over All Quantity');
    //             return;
    //         }
    //     }

    //     const updated = [...addedBillingItems];
    //     updated[index][field] = value;
    //     setAddedBillingItems(updated);
    // };


    const handleBillingItemChange = (index, field, value) => {
        const updated = [...addedBillingItems];

        if (field === "billingItemId") {
            const selectedOption = billingItemOptions.find((opt) => opt.value === value);

            if (selectedOption) {
                const itemOverall = Number(selectedOption.overallQuantity || 0);
                const overAll = Number(quantity || 0);

                let autoQty = "";

                if (itemOverall > overAll) {
                    // stock greater → set to overall
                    autoQty = overAll;
                } else if (itemOverall === overAll) {
                    // stock equal → set to overall
                    autoQty = overAll;
                }
                // else stock < overall → leave as empty

                updated[index] = {
                    ...updated[index],
                    billingItemId: value,
                    billingItemQuantity: autoQty,
                };
            } else {
                updated[index].billingItemId = value;
                updated[index].billingItemQuantity = "";
            }
        }

        else if (field === "billingItemQuantity") {
            let entered = Number(value || 0);

            const totalEntered = addedBillingItems.reduce((sum, item, i) => {
                if (i !== index) return sum + Number(item.billingItemQuantity || 0);
                return sum;
            }, 0);

            const overAll = Number(quantity || 0);
            const remainingQty = overAll - totalEntered;

            if (entered > remainingQty) {
                toast.error(`You cannot enter more than the Over All Quantity`);
                entered = remainingQty;
            }

            const selectedOption = billingItemOptions.find(
                (opt) => opt.value === updated[index].billingItemId
            );

            if (selectedOption?.overallQuantity && entered > Number(selectedOption.overallQuantity)) {
                toast.error(
                    `Quantity cannot exceed ${selectedOption.overallQuantity} for this item`
                );
                entered = Number(selectedOption.overallQuantity);
            }

            updated[index].billingItemQuantity = entered;
        }

        setAddedBillingItems(updated);
    };



    const handleAddRow = () => {
        setAddedBillingItems((prev) => [...prev, { billingItemId: '', billingItemQuantity: '' }]);
    };


    // const handleSave = () => {
    //     const formattedItems = addedBillingItems.map((billingItem) => {
    //         const selectedBillingItemData = billingItemsData?.result?.find(
    //             (bItem) => bItem._id === billingItem.billingItemId
    //         );

    //         return {
    //             itemId: itemData?.itemId || '',
    //             itemName: itemData?.itemName || '',
    //             bagType: itemData?.productBag || '',
    //             productType: itemData?.productType || '',
    //             quantityKg: itemData?.productQuantity || '',
    //             count: itemData?.productCount || '',
    //             overallQuantity: quantity,
    //             itemBag: selectedBillingItemData
    //                 ? `Item ID ${selectedBillingItemData.itemId} - ${selectedBillingItemData.productName} - ${selectedBillingItemData.overallQuantity} kg`
    //                 : '',
    //             qty: billingItem.billingItemQuantity || '',
    //             billingItemId: selectedBillingItemData?._id || '',
    //             orderId: orderId,
    //         };
    //     });

    //     let existingData = JSON.parse(localStorage.getItem('approvedItems')) || [];

    //     const currentItemId = itemData?.itemId;
    //     const currentOverallQty = Number(itemData?.overallQuantity || quantity || 0);

    //     const existingTotalQty = existingData.reduce((sum, item, idx) => {
    //         if (item.itemId === currentItemId && (editIndex === undefined || idx !== editIndex)) {
    //             return sum + Number(item.qty || 0);
    //         }
    //         return sum;
    //     }, 0);

    //     const newQtyTotal = formattedItems.reduce((sum, item) => sum + Number(item.qty || 0), 0);

    //     if (existingTotalQty + newQtyTotal > currentOverallQty) {
    //         toast.error("Total quantity exceeds Over All Quantity!");
    //         return;
    //     }

    //     // 🛠 Step 2: Merge or update items
    //     // for (const newItem of formattedItems) {
    //     //     const duplicateIndex = existingData.findIndex(
    //     //         (item, index) =>
    //     //             item.itemId === newItem.itemId &&
    //     //             item.billingItemId === newItem.billingItemId &&
    //     //             (editIndex === undefined || index !== editIndex)
    //     //     );

    //     //     if (duplicateIndex !== -1) {
    //     //         const existingQty = Number(existingData[duplicateIndex].qty || 0);
    //     //         const newQty = Number(newItem.qty || 0);
    //     //         existingData[duplicateIndex].qty = (existingQty + newQty).toString();
    //     //     } else {
    //     //         if (editIndex !== undefined) {
    //     //             existingData.splice(editIndex, 1, newItem);
    //     //         } else {
    //     //             existingData.push(newItem);
    //     //         }
    //     //     }
    //     // }

    //     for (const newItem of formattedItems) {
    //         const duplicateIndex = existingData.findIndex(
    //             (item, index) =>
    //                 item.itemId === newItem.itemId &&
    //                 item.billingItemId === newItem.billingItemId &&
    //                 item.bagType === newItem.bagType &&
    //                 (editIndex === undefined || index !== editIndex)
    //         );

    //         if (duplicateIndex !== -1) {
    //             const existingQty = Number(existingData[duplicateIndex].qty || 0);
    //             const newQty = Number(newItem.qty || 0);
    //             existingData[duplicateIndex].qty = (existingQty + newQty).toString();

    //             if (editIndex !== undefined && editIndex !== duplicateIndex) {
    //                 existingData.splice(editIndex, 1);
    //             }
    //         } else {
    //             if (editIndex !== undefined) {
    //                 existingData.splice(editIndex, 1, newItem);
    //             } else {
    //                 existingData.push(newItem);
    //             }
    //         }
    //     }



    //     localStorage.setItem('approvedItems', JSON.stringify(existingData));

    //     toast.success(editIndex !== undefined ? 'Item updated successfully' : 'Item added successfully');
    //     handleClose();
    // };


    const handleSave = () => {
        // ✅ Validation: required fields + per-item stock check
        for (const billingItem of addedBillingItems) {
            if (!billingItem.billingItemId) {
                toast.error("Please select a Billing Item");
                return;
            }
            if (!billingItem.billingItemQuantity || Number(billingItem.billingItemQuantity) <= 0) {
                toast.error("Please enter a valid Quantity");
                return;
            }

            // 🔥 New validation: check against each item's overallQuantity
            const itemData = billingItemOptions.find(
                (opt) => opt.value === billingItem.billingItemId
            );

            if (
                itemData?.overallQuantity &&
                Number(billingItem.billingItemQuantity) > Number(itemData.overallQuantity)
            ) {
                toast.error(
                    `Quantity for "${itemData.label}" cannot exceed ${itemData.overallQuantity}`
                );
                return;
            }
        }

        // ✅ Build formatted items
        const formattedItems = addedBillingItems.map((billingItem) => {
            const selectedBillingItemData = billingItemsData?.result?.find(
                (bItem) => bItem._id === billingItem.billingItemId
            );
        console.log(selectedBillingItemData,"selectedBillingItemData");

            return {
                itemId: itemData?.itemId || "",
                itemName: itemData?.itemName || "",
                bagType: itemData?.productBag || "",
                productType: itemData?.productType || "",
                quantityKg: itemData?.productQuantity || "",
                count: itemData?.productCount || "",
                overallQuantity: quantity,
                // itemBag: selectedBillingItemData
                //     ? `Item ID ${selectedBillingItemData.itemId} - ${selectedBillingItemData.productName} - ${selectedBillingItemData.overallQuantity} kg`
                //     : "",
                itemBag: selectedBillingItemData
    ? `${selectedBillingItemData?.inventoryId?.farmerId?.firstName} - ID ${selectedBillingItemData.itemId} - ${selectedBillingItemData.productName} - ${selectedBillingItemData.overallQuantity}kg${selectedBillingItemData.productBag ? ' - ' + selectedBillingItemData.productBag : ''}`
    : "",

                qty: billingItem.billingItemQuantity || "",
                billingItemId: selectedBillingItemData?._id || "",
                orderId: orderId,
            };
        });

        

        let existingData = JSON.parse(localStorage.getItem("approvedItems")) || [];

        const currentItemId = itemData?.itemId;
        const currentOverallQty = Number(itemData?.overallQuantity || quantity || 0);

        const existingTotalQty = existingData.reduce((sum, item, idx) => {
            if (item.itemId === currentItemId && (editIndex === undefined || idx !== editIndex)) {
                return sum + Number(item.qty || 0);
            }
            return sum;
        }, 0);

        const newQtyTotal = formattedItems.reduce((sum, item) => sum + Number(item.qty || 0), 0);

        if (existingTotalQty + newQtyTotal > currentOverallQty) {
            toast.error("Total quantity exceeds Over All Quantity!");
            return;
        }

        // ✅ Merge or update
        for (const newItem of formattedItems) {
            const duplicateIndex = existingData.findIndex(
                (item, index) =>
                    item.itemId === newItem.itemId &&
                    item.billingItemId === newItem.billingItemId &&
                    item.bagType === newItem.bagType &&
                    (editIndex === undefined || index !== editIndex)
            );

            if (duplicateIndex !== -1) {
                const existingQty = Number(existingData[duplicateIndex].qty || 0);
                const newQty = Number(newItem.qty || 0);
                existingData[duplicateIndex].qty = (existingQty + newQty).toString();

                if (editIndex !== undefined && editIndex !== duplicateIndex) {
                    existingData.splice(editIndex, 1);
                }
            } else {
                if (editIndex !== undefined) {
                    existingData.splice(editIndex, 1, newItem);
                } else {
                    existingData.push(newItem);
                }
            }
        }

        localStorage.setItem("approvedItems", JSON.stringify(existingData));

        toast.success(editIndex !== undefined ? "Item updated successfully" : "Item added successfully");
        handleClose();
    };







    const handleClose = () => {
        if (typeof closePopup === 'function') closePopup();
    };

    return (
        <div className={styles.createOrdersContainers}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>{editIndex !== undefined ? 'Edit Item' : 'Add Item'}</h2>
                <span className={styles.closeIcon} onClick={handleClose}>✕</span>
            </div>

            <div className={styles.container}>
                <div className={styles.formSections}>
                    <div className={styles.formLeft}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Item Category</label>
                            <Select
                                className={styles.customSelect}
                                value={
                                    itemData?.itemName
                                        ? { value: selectedItem, label: itemData.itemName }
                                        : null
                                }
                                options={[
                                    itemData?.itemName
                                        ? { value: selectedItem, label: itemData.itemName }
                                        : { value: '', label: 'No Item' }
                                ]}
                                // isDisabled
                                isSearchable={false}
                                placeholder="Select Item"
                                isDisabled={true}
                                // isSearchable={false}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        border: '1px solid #6D6D6D',
                                        borderRadius: '6px',
                                        fontSize: '16px',
                                        minHeight: '50px',
                                        boxShadow: 'none',
                                        color: 'black',
                                        fontWeight: '600',
                                        backgroundColor: '#f5f5f5',
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        color: 'black',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                    }),
                                }}
                            />
                        </div>
                    </div>

                    <div className={styles.formRights}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Over All Quantity</label>
                            <input
                                placeholder="Enter Quantity"
                                className={styles.input}
                                type="number"
                                min="0.1"
                                step="0.1"
                                value={quantity}
                                readOnly
                            />

                        </div>
                    </div>
                </div>

                {/* {addedBillingItems.map((item, index) => (
                    <div key={index} className={styles.formSections}>
                        <div className={styles.formLeft}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Billing Item</label>
                                <select
                                    className={styles.inputs}
                                    value={item.billingItemId}
                                    onChange={(e) =>
                                        handleBillingItemChange(index, 'billingItemId', e.target.value)
                                    }
                                >
                                    <option value="">Select Item</option>
                                    {billingItemOptions
                                        .filter((opt) => {
                                            const isAlreadySelected = addedBillingItems.some(
                                                (bi, i) => i !== index && bi.billingItemId === opt.value
                                            );
                                            return !isAlreadySelected || opt.value === item.billingItemId;
                                        })
                                        .map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>

                        <div className={styles.formRights}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Quantity</label>
                                <input
                                    type="number"
                                    className={styles.input}
                                    placeholder="Enter Quantity"
                                    min="1"
                                    value={item.billingItemQuantity}
                                    onChange={(e) =>
                                        handleBillingItemChange(index, 'billingItemQuantity', e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                ))} */}
                {addedBillingItems.map((item, index) => (
                    <div key={index} className={styles.formSections}>
                        <div className={styles.formLeft}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Billing Item</label>
                                <select
                                    className={styles.inputs}
                                    value={item.billingItemId}
                                    onChange={(e) =>
                                        handleBillingItemChange(index, "billingItemId", e.target.value)
                                    }
                                >
                                    <option value="">Select Item</option>
                                    {billingItemOptions
                                        .filter((opt) => {
                                            const isAlreadySelected = addedBillingItems.some(
                                                (bi, i) =>
                                                    i !== index && bi.billingItemId === opt.value
                                            );
                                            return !isAlreadySelected || opt.value === item.billingItemId;
                                        })
                                        .map((opt) => (
                                            <option key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>

                        <div className={styles.formRights}>
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Quantity</label>
                                <input
                                    type="number"
                                    className={styles.input}
                                    placeholder="Enter Quantity"
                                    min="1"
                                    value={item.billingItemQuantity}
                                    onChange={(e) =>
                                        handleBillingItemChange(
                                            index,
                                            "billingItemQuantity",
                                            e.target.value
                                        )
                                    }
                                    disabled={!item.billingItemId}
                                />
                            </div>
                        </div>
                    </div>
                ))}


                {isLoading && <p>Loading billing items...</p>}
                {isError && <p style={{ color: 'red' }}>Failed to load billing items</p>}

                {/* <div className={styles.footerButtons}>
                    <button className={styles.save} onClick={handleAddRow}>+ Add</button>
                </div> */}

                <div className={styles.footerButtons}>
                    <button className={styles.cancel} onClick={handleClose}>Cancel</button>
                    <button className={styles.save} onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

export default ApprovePopup;








